import dynamic from 'next/dynamic';

import { useCatalogData } from '@contexts/catalog-data';

import classes from '../ProductCatalog.module.scss';

const Pagination = dynamic(() => import('@components/pagination/Pagination').then((mod) => mod.Pagination));

const PRODUCTS_PER_PAGE = 12;

const CatalogPagination = () => {
  const { isLoading, catalog, loadMoreProducts } = useCatalogData();

  const totalPages =
    catalog && catalog.totalDocs && catalog.docs ? Math.ceil(catalog.totalDocs / PRODUCTS_PER_PAGE) : 0;

  return (
    <Pagination
      loadMoreTitle={`Показати ще ${PRODUCTS_PER_PAGE} товарів`}
      onLoadMore={loadMoreProducts}
      disabled={isLoading}
      totalPages={totalPages}
      className={classes.paginationWrapper}
    />
  );
};

export default CatalogPagination;
